export default "__VITE_ASSET__pbA17iYe__"